import crz from '@/services/api/crz';

export default {
    namespaced: true,
    state: {
        crzStructure: null,
        crzLoader: false
    },
    getters: {
        getCrzStructure (state) {
            return state.crzStructure;
        },
        getCrzLoader: (state) => state.crzLoader
    },
    mutations: {
        setCrzStructure (state, data) {
            state.crzStructure = data;
        },
        setCrzLoader (state, data) {
            state.crzLoader = data;
        }
    },
    actions: {
        getCrzStructure (context, file) {
            return crz.getJSONData(file).then((data) => {
                context.commit('setCrzStructure', data.data);
            });
        }
    }
};
